import { OverlayTrigger, Tooltip } from "react-bootstrap";

const CategoryCard = ({
  title,
  incidentCount = 0,
  completedIncidentCount = 0,
}) => {
  const getInitials = (text) => {
    if (!text) return "";
    let cleanText = text.replace(/\(.*?\)/g, "");
    cleanText = cleanText.replace(/[0-9-]/g, "").trim();
    const words = cleanText.split(" ").filter(Boolean);
    const first = words[0]?.charAt(0) || "";
    const last = words.length > 1 ? words[words.length - 1]?.charAt(0) : "";
    return (first + last).toUpperCase();
  };

  const pendingCount = incidentCount - completedIncidentCount;

  const percentage =
    incidentCount > 0
      ? Math.round((completedIncidentCount / incidentCount) * 100)
      : 0;

  return (
    <div className="card border-0 shadow-sm p-3 h-100" style={{ cursor: "pointer" }}>
      {/* Top */}
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-3">
          <div
            className="rounded-circle d-flex justify-content-center align-items-center text-dark flex-shrink-0"
            style={{ width: "45px", height: "45px", backgroundColor: "#BDCBDB" }}
          >
            {getInitials(title)}
          </div>

          <h6 className="mb-0">{title}</h6>
        </div>
      </div>

      <div className="d-flex align-items-center ps-5 ms-3">
        <div className="progress flex-grow-1 rounded-pill" style={{ height: "5px" }}>
          <div
            className="progress-bar category-gradient-bar rounded-pill"
            role="progressbar"
            style={{ width: `${percentage}%` }}
          />
        </div>

        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id={`tooltip-${title}`}>
              <div>
                <div className="fw-semibold">
                  Completed:{" "}
                  <span className="text-success fw-semibold">
                    {completedIncidentCount}
                  </span>
                </div>
                <div className="fw-semibold">
                  Pending:{" "}
                  <span className="text-danger fw-semibold">
                    {pendingCount}
                  </span>
                </div>
              </div>
            </Tooltip>
          }
        >
          <span
            className="ms-2 small text-primary"
            style={{ cursor: "pointer", whiteSpace: "nowrap" }}
          >
            {completedIncidentCount}/{incidentCount}
          </span>
        </OverlayTrigger>
      </div>
    </div>
  );
};

export default CategoryCard;